import React from "react";
import { ImgV2 } from "../../ImgV2";
export const Category = ({ categoryTitle, elements }) => (React.createElement("div", { className: 'category__root' },
    React.createElement("p", null, categoryTitle),
    React.createElement("div", { className: "category__imagesWrapper" }, elements.length > 0 && elements.map((a, i) => (React.createElement("a", { target: "_blank", rel: "noopener noreferrer", key: `unique${a.icon}`, href: a.appUrl },
        React.createElement(ImgV2, { src: a.icon })))))));
